import React, { useRef, useState, useEffect } from "react";
import Slider from "react-slick";
import styles from "./AccreditationContent.module.scss";
import Image from "next/image";
import left from "../../assets/icons/left-circle-button.svg";
import right from "../../assets/icons/right-circle-button.svg";
import { gotoNext, gotoPrev } from "../../helper/sliderControls";

const AccreditationContent = ({ datas }) => {
  const customSlider = useRef(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [slidesToShow, setSlidesToShow] = useState(3);

  const handleBeforeChange = (oldIndex, newIndex) => {
    setCurrentIndex(newIndex);
  };

  useEffect(() => {
    const updateSlidesToShow = () => {
      if (window.innerWidth < 1024) {
        setSlidesToShow(1);
      } else {
        setSlidesToShow(3);
      }
    };

    window.addEventListener("resize", updateSlidesToShow);
    updateSlidesToShow();

    return () => {
      window.removeEventListener("resize", updateSlidesToShow);
    };
  }, []);

  const lastSlideIndex = datas?.icon?.results?.length;
  const singleItem = lastSlideIndex === 1;

  return (
    <>
    { datas && (
    <div className={styles.main_content}>
      <div
        id="sliderwpcard"
        className={`sliderwpcard section_pading accreditation-sec ${styles.sliderwpcard}`}
        data-testid="ac-container-id"
      >
        <div className="container">
          <div className={`slider-container sliderwp ${styles.sliderwp}`}>
            <h1>{datas?.title}</h1>
            <p className={styles.main_para}>{datas?.summary}</p>
            {singleItem ? (
              <div className={styles.singleItemWrapper}>
                <div className={styles.singleItem}>
                  <Image
                    src={datas?.icon?.results[0]?.fileUrl}
                    height={84}
                    width={84}
                    alt="logo"
                    className={styles.singleImage}
                  />
                </div>
              </div>
            ) : (
              <Slider
                dots={false}
                infinite={false}
                speed={500}
                slidesToShow={slidesToShow}
                slidesToScroll={1}
                // {...AccreditationSettings}
                beforeChange={handleBeforeChange}
                ref={customSlider}
              >
                {datas?.icon?.results?.map((item, index) => (
                  <div key={index} className={styles.slideItem}>
                    <Image
                      src={item?.fileUrl}
                      height={84}
                      width={84}
                      alt="logo"
                    />
                  </div>
                ))}
              </Slider>
            )}
            {!singleItem && datas && (
              <div className={styles.btn_scroll_wp}>
                <button
                  onClick={() => gotoPrev(customSlider)}
                  disabled={currentIndex === 0}
                  className={currentIndex === 0 ? styles.disabledButton : ""}
                >
                  <Image
                    src={left}
                    alt="previous"
                    width={24}
                    height={24}
                    sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                  />
                </button>
                <button
                  onClick={() => gotoNext(customSlider)}
                  disabled={currentIndex + slidesToShow >= lastSlideIndex}
                  className={
                    currentIndex + slidesToShow >= lastSlideIndex
                      ? styles.disabledButton
                      : ""
                  }
                >
                  <Image
                    src={right}
                    alt="next"
                    width={24}
                    height={24}
                    sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                  />
                </button>
              </div>
            )}
          </div>
          {datas?.description && (
            <div className={styles.content_text}>
              <p
                dangerouslySetInnerHTML={{
                  __html: datas?.description?.content?.[0]?.content?.[0]?.text,
                }}
              />
            </div>
          )}
        </div>
      </div>
    </div>
    )}
  </>
  );
};

export default AccreditationContent;
